import React from 'react';
import {Table} from '..';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {
    id: 'building',
    numeric: false,
    disabledPadding: true,
    label: 'Building',
  },
  {
    id: 'entrance',
    numeric: false,
    disabledPadding: false,
    label: 'Entrance',
  },
  {
    id: 'totalPaid',
    numeric: false,
    disabledPadding: false,
    label: 'Total paid',
  },
  {
    id: 'totalCustomers',
    numeric: false,
    disabledPadding: false,
    label: 'Total customers',
  },
  {
    id: 'month',
    numeric: false,
    disabledPadding: true,
    label: 'Month',
  },
];

const DATA_CELLS = [
  'building',
  'entrance',
  'totalPaid',
  'totalCustomers',
  'month',
];

const PaymentsOverviewTable = ({payments, loading}) => {
  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={payments}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      noToolbar
    />
  );
};

export default PaymentsOverviewTable;
